/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Col, Label, Row } from 'reactstrap';
import {
  InitiateAlarm,
  alarmProtocolToggle,
  initiateAlarmTest,
  getAlarmTest,
  updateAlarmTest,
  fetchAlarmResult,
  addNote,
  selectedProtocol,
  getAllPortsName,
} from '../../../actions/EpikBoxes';
import { useObiIdAndPortNumber } from '../../../hooks';
import { TOOLTIPS_TEXT } from '../../../lib/constants';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import Checkbox from '../../Checkbox';
import InfoPopup from '../../InfoPopup';
import DropdownSelect from '../../ProposalGenerator/DropdownSelect';
import Toggle from '../../Toggle';
import utils from '../../../lib/utils';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';
import { setTestStatusAlaram } from '../../../actions/EpikBoxes';
const AlarmProtocol = ({user}) => {
  const dispatch = useDispatch();
  const box = useSelector(state => state.AppState.boxDetails.box);
  const numberData = useSelector(state => state.AppState.numbers.numberByID);
  const alarmRelayStatus = useSelector(state => state.AppState.alarmRelayStatus);
  const fetchResultStatus = useSelector(state => state.UIState.epikBoxes.fetchResultStatus);

  const { obiId, portNumber } = useObiIdAndPortNumber();

  const token = localStorage.getItem('jwtToken') || null;
  const typeOptions = [
    { label: 'Contact ID', value: 'contactId' },
    { label: 'Modem 3', value: 'modem3', disabledItem: true },
  ];
  const operationOptions = [
    { label: 'Test', value: 'Test' },
    { label: 'Live', value: 'Live', disabledItem: true },
  ];
  const [numberDetails, setNumberDetails] = useState(null);
  const [securityModal, setSecurityModal] = useState(false);
  const [selectedAlarm] = useState(typeOptions[0]);
  const [selectedMode, setSelectedMode] = useState(operationOptions[0]);
  const [operationList, setOperationList] = useState(operationOptions);

  const [toggle, setToggle] = useState(false);
  const [testStatus, setTestStatus] = useState(false);
  const [disableFetch, setDisableFetch] = useState(false);
  const [testProgress, setTestProgress] = useState(null);
  const [initiated, setInitiated] = useState(false);
  const [companionPort, setCompanionPort] = useState(null);
  const [allPorts, setAllPorts] = useState([])
  const [isCompanion, setIsCompanion] = useState(false);
  const getPorts = async () => {
    let ports = await dispatch(getAllPortsName(token, box._id))
    ports = ports.map(label => ({ label, value: label }))
    if (!companionPort)
      setCompanionPort(ports[0])
    setAllPorts(ports)
    console.log({ ports })
  }
  useEffect(() => {
    getPorts()
  }, [])
  useEffect(() => {
    setToggle(alarmRelayStatus?.status);
  }, [alarmRelayStatus]);

  const onChangeValues = e => {
    setSelectedMode(e);
  };

  useEffect(() => {
    setNumberDetails(numberData);
  }, [numberData]);

  useEffect(() => {
    const protocol = {
      operationMode: selectedMode.value,
      portocolSelection: selectedAlarm.label,
    };
    dispatch(selectedProtocol(protocol));
  }, [selectedMode]);

  const miniTimer = () => {
    setTimeout(() => {
      setDisableFetch(false);
    }, 120000);
  };

  const onInitiate = async () => {
    dispatch(setTestStatusAlaram(true));
    setTestProgress(null);

    setDisableFetch(true);
    const body = {
      numberID: numberDetails?._id,
      portocolSelection: selectedAlarm.label,
      portNumber,
      companionPort: isCompanion ? companionPort.value : null
    };
    const initiateTest = await dispatch(initiateAlarmTest(token, box._id, body));
    if (initiateTest) {
      if (Object.keys(initiateTest).includes('success')) {
        return toast.info(initiateTest?.message);
      }
      const noteBody = {
        note: `Alarm Test Initiated for ${numberDetails?.number} at ${utils.getDateTimeFormat(new Date(), 'both')}`,
        type: 'system',
        file: '',
      };
      await dispatch(addNote(token, box._id, noteBody));
      setInitiated(true);
      miniTimer();
      setNumberDetails(initiateTest);
      const timer = await dispatch(getAlarmTest(token, box._id));
      await dispatch(InitiateAlarm(timer?.remainingTime || 0));
    } else {
      setDisableFetch(false);
    }
  };

  const onFetchResults = async () => {
    setTestProgress(null);
    const testResult = await dispatch(
      fetchAlarmResult(token, box._id, numberDetails._id, obiId, portNumber),
    );
    if (testResult?.fetchResponse?.result === 'In Progress') {
      setDisableFetch(true);
      miniTimer();
      setTestProgress(testResult?.fetchResponse);
    } else if (testResult?.fetchResponse?.result === 'Failed') {
      setTestProgress(testResult?.fetchResponse);
      const timer = await dispatch(getAlarmTest(token, box._id));
      await dispatch(InitiateAlarm(timer?.remainingTime || 0));
    } else if (testResult?.fetchResponse?.result === 'Passed') {
      const noteBody = {
        note: `Alarm Test Passed Successfully for ${numberDetails?.number}`,
        type: 'system',
        file: '',
      };
      setTestProgress(testResult?.fetchResponse);
      setNumberDetails(testResult?.updatedNumber);
      await dispatch(updateAlarmTest(token, box._id));
      await dispatch(InitiateAlarm(0));
      await dispatch(addNote(token, box._id, noteBody));
      setTestStatus(true);
    }
  };

  // const onToggle = async () => {
  //   setSecurityModal(true);
  //   // setToggle(true);
  // };
  const onToggle = async () => {
    let checkPermission =true
    if (user?.permissionsGroup == "Engineering" || user?.epikEngineering) {
       checkPermission = false
    }
    if (checkPermission && !toggle && box?.datacenter === "dl") {
      toast.error('APR is unavailable in Dallas DC');
      return;
    }
    // setSecurityModal(true);
    setToggle(!toggle);
    onSecurityConfirm()
  };

  const onSecurityConfirm = async () => {
    if (!toggle) {
      const body = {
        numberID: numberDetails?._id,
        isEnabled: true,
        obiID: obiId || '',
        portNumber,
      };
      const res = await dispatch(alarmProtocolToggle(token, box._id, body));
      if (res) {
        setNumberDetails(res);
        setToggle(res?.alarmRelayInfo?.isEnabled);
        setSecurityModal(false);
      }
    } else {
      const body = {
        numberID: numberDetails?._id,
        isEnabled: false,
        obiID: obiId || '',
        portNumber,
      };
      const res = await dispatch(alarmProtocolToggle(token, box._id, body));
      if (res) {
        const timer = await dispatch(getAlarmTest(token, box._id));
        await dispatch(InitiateAlarm(timer?.remainingTime || 0));
        setNumberDetails(res);
        setToggle(res?.alarmRelayInfo?.isEnabled);
      }
      // setSecurityModal(false);
    }
  };

  useEffect(() => {
    if (numberDetails?.alarmRelayInfo?.companionPort && numberDetails.alarmRelayInfo.isTestStarted) {
      let { companionPort } = numberDetails.alarmRelayInfo
      setCompanionPort({ label: companionPort, value: companionPort })
      setIsCompanion(true)
    }
    setTestStatus(numberDetails?.alarmRelayInfo?.isTestPassed);
    // setToggle(numberDetails?.alarmRelayInfo?.isEnabled);
    if (numberDetails?.alarmRelayInfo?.isEnabled !== undefined) {
      setToggle(numberDetails.alarmRelayInfo.isEnabled);
    }
    if (numberDetails?.alarmRelayInfo?.isTestPassed) {
      const newOperationList = operationOptions.map(item => {
        if (item.value === 'Live') {
          return { ...item, disabledItem: false };
        }
        return item;
      });
      setOperationList(newOperationList);
    }
    if (numberDetails?.alarmRelayInfo?.operationMode === 'Test') {
      setSelectedMode(operationOptions[0]);
      if (!numberDetails?.alarmRelayInfo?.isTestPassed) {
        setOperationList(operationOptions);
      }
    } else if (numberDetails?.alarmRelayInfo?.operationMode === 'Live') {
      setSelectedMode({ ...operationOptions[1], disabledItem: false });
    }
  }, [numberDetails]);
  const enableAlarmProtocol = getPermissionForComponent('enableAlarmProtocol',user?.permissionsGroup);
  const [enableAlarm,setEnableAlarm] = useState(enableAlarmProtocol)
  return (
    (enableAlarm === 'write' || enableAlarm === 'read'|| enableAlarm === 'both') && (
      <Col>
      <Row className="mb-2">
        <Label for="enabled" sm={8}>
          Enable Alarm Protocol Relay
        </Label>
        <Toggle value={toggle} onToggle={onToggle} disabled={enableAlarm === 'read'} />
      </Row>
      {toggle && (
        <Col sm={12}>
          <Row className="mb-2">
            <Col>
              <p>Alarm Protocol Selection</p>
            </Col>
            <Col sm={6}>
              <DropdownSelect
                options={typeOptions}
                selectedOption={selectedAlarm}
                onSelect={onChangeValues}
                warningText="cannot be selected at this time"
                disabled={enableAlarm === 'read'}
              />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col sm={6} className="d-flex align-items-flex-start">
              <p>Operation Mode</p>
            </Col>
            <Col sm={6}>
              <DropdownSelect
                options={operationList}
                selectedOption={selectedMode}
                onSelect={onChangeValues}
                disabled={enableAlarm === 'read'}
                warningText="Alarm Protocol Relay cannot be set to live status until a test is complete."
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <p>Disable Companion Port</p>
            </Col>
            <Col sm={6} className="d-flex justify-content-end">
              {/* <Checkbox onChange={e => setIsCompanion(e)} checked={isCompanion} disabled={enableAlarm === 'read'} /> */}
              <Checkbox
                  onChange={e => !(enableAlarm === 'read') && setIsCompanion(e)}
                  checked={isCompanion}
                  disabled={enableAlarm === 'read'}
                />
              <sup>
                <InfoPopup id="APR_COMPANION" text={TOOLTIPS_TEXT.APR_COMPANION} />
              </sup>
            </Col>
          </Row>
          {isCompanion && <Row className="mb-2">
            <Col sm={6} className="d-flex align-items-flex-start">
              <p>Select Port</p>
            </Col>
            <Col sm={6}>
              <DropdownSelect
                options={allPorts}
                selectedOption={companionPort}
                onSelect={e => setCompanionPort(e)}
                disabled={enableAlarm === 'read'}
              />
            </Col>
          </Row>}
          <Row className="mb-3">
            <Col sm={12} className="d-flex flex-column justify-content-end align-items-end">
              <Button onClick={onInitiate} style={{ margin: 0 }} color="primary" disabled={enableAlarm === 'read'}>
                Initiate Test
              </Button>
              {initiated && (
                <p>
                  Initiated Time:
                  {` ${utils.getDateTimeFormat(new Date(), 'both')}`}
                </p>
              )}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col>
              <p>Alarm Test Passed</p>
            </Col>
            <Col sm={6} className="d-flex justify-content-end">
                <Checkbox
                  checked={testStatus}
                  onChange={() => { }}
                  readOnly
                />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col sm={12} className="d-flex flex-column justify-content-end align-items-end">
              {fetchResultStatus && (
                <Button
                  disabled={disableFetch || enableAlarm === 'read'}
                  onClick={onFetchResults}
                  style={{ margin: 0 }}
                  color="primary"
                >
                  Fetch Results
                </Button>
              )}
              {testProgress && (
                <>
                  <p>
                    Fetch Time:
                    {` ${utils.getDateTimeFormat(testProgress?.timeStamp, 'both')}`}
                  </p>
                  <p
                    style={{
                      color: testProgress?.result === 'Passed' ? '#4BB543' : '#dc3545',
                      fontWeight: 'bold',
                    }}
                  >
                    {testProgress?.result}
                  </p>
                </>
              )}
            </Col>
          </Row>
        </Col>
      )}
      <AddSecurityCodeModal
        isOpen={securityModal}
        onCancel={() => {
          setSecurityModal(false);
        }}
        onConfirm={onSecurityConfirm}
        alarmProtocol
        featureName='alarmProtocol'
      />
    </Col>
    )
  );
};

export default AlarmProtocol;
